<template>
  <div class="dd-profit-caption-wrap">
    <el-tooltip effect="dark" placement="top">
        <div slot="content" style="white-space: pre-line;">{{ tipTxt }}</div>
        <i class="el-icon-question"></i>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        tipTxt: "达人的佣金=（实付金额 + 主播券金额 + 平台券金额 + 支付通道补贴 - 运费金额 ）佣金率。对于这个结果，平台会扣除10%的服务费。\n例如：一个订单的实付金额为16.5元，平台补贴为3元，则佣金基数为19.5元。如果佣金率为2%，则佣金为0.39元，平台会扣除0.04元的服务费，最后达人会得到0.35元的佣金。"
      }
    }
  }
</script>

<style scoped lang="less">
.dd-profit-caption-wrap{
  margin-left: 4px;
  cursor: pointer;
  .el-icon-question{
    color: #808080;
  }
}
</style>